import { render, staticRenderFns } from "./SchemaInputDetail.vue?vue&type=template&id=d0cea35c&scoped=true&"
import script from "./SchemaInputDetail.vue?vue&type=script&lang=js&"
export * from "./SchemaInputDetail.vue?vue&type=script&lang=js&"
import style0 from "./SchemaInputDetail.vue?vue&type=style&index=0&id=d0cea35c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cea35c",
  null
  
)

export default component.exports